import { TextChip } from "@/toggle-ui-kit/chip";

export const StandardChip = () => {
  return (
    <TextChip size="medium" className="bg-slate-200 text-slate-600">
      표준
    </TextChip>
  );
};

export const ExtendedChip = () => {
  return (
    <TextChip size="medium" className="bg-purple-100 text-purple-600">
      확장
    </TextChip>
  );
};
